/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeRiskMatrix.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Risk Matrix Type Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, January 21, 2019 - 05:31:24 AM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      01/21/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const RISKMATRIX_LIST_CONTAINER_LOADED = 'RISKMATRIX_LIST_CONTAINER_LOADED';
export const RISKMATRIX_LIST_CONTAINER_UNLOADED = 'RISKMATRIX_LIST_CONTAINER_UNLOADED';
export const RISKMATRIX_LIST_TABLE_LOADED = 'RISKMATRIX_LIST_TABLE_LOADED';
export const RISKMATRIX_LIST_TABLE_UNLOADED = 'RISKMATRIX_LIST_TABLE_UNLOADED';

export const RISKMATRIX_SELECT_ROW = 'RISKMATRIX_SELECT_ROW';

export const RISKMATRIX_ADD = 'RISKMATRIX_ADD';
export const RISKMATRIX_EDIT = 'RISKMATRIX_EDIT';
export const RISKMATRIX_DELETE = 'RISKMATRIX_DELETE';
export const RISKMATRIX_OPEN_WARNING = 'RISKMATRIX_OPEN_WARNING';
export const RISKMATRIX_CLOSE_WARNING = 'RISKMATRIX_CLOSE_WARNING';

export const RISKMATRIX_EDIT_CONTAINER_LOADED = 'RISKMATRIX_EDIT_CONTAINER_LOADED';
export const RISKMATRIX_EDIT_CONTAINER_UNLOADED = 'RISKMATRIX_EDIT_CONTAINER_UNLOADED';
export const RISKMATRIX_EDIT_FORM_LOADED = 'RISKMATRIX_EDIT_FORM_LOADED';
export const RISKMATRIX_EDIT_FORM_UNLOADED = 'RISKMATRIX_EDIT_FORM_UNLOADED';

export const RISKMATRIX_SET_CGROUP_SELECT = 'RISKMATRIX_SET_CGROUP_SELECT';
export const RISKMATRIX_SET_PGROUP_SELECT = 'RISKMATRIX_SET_PGROUP_SELECT';
export const RISKMATRIX_SET_RGROUP_SELECT = 'RISKMATRIX_SET_RGROUP_SELECT';
export const RISKMATRIX_EDIT_DATA_LOAD = 'RISKMATRIX_EDIT_DATA_LOAD';

export const RISKMATRIX_EDIT_CONTAINER_SUBMIT = 'RISKMATRIX_EDIT_CONTAINER_SUBMIT';
export const RISKMATRIX_EDIT_CONTAINER_CANCEL = 'RISKMATRIX_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeRiskMatrix.js